import { useEffect, useState } from 'react';
import HeroSection from './components/HeroSection';
import PainPointsSection from './components/PainPointsSection';
import SolutionSection from './components/SolutionSection';
import BusinessValueSection from './components/BusinessValueSection';
import LongTermStrategySection from './components/LongTermStrategySection';
import CTASection from './components/CTASection';
// @ts-ignore
import sectionItemService from '../../services/sectionItemService';
// @ts-ignore
import { useAutoSEO } from '../../hooks/useSEOFromRoute';

const PAGE_SLUG = 'trien-khai-devsecops-cho-doanh-nghiep';

export default function ServiceImplementDevsecopsPage() {
  // Auto fetch SEO from database based on route
  useAutoSEO();

  const [sectionItems, setSectionItems] = useState<{
    businessChallenges?: any[];
    process?: any[];
    benefits?: any[];
    whyChoose?: any[];
  }>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const navbar = document.querySelector('.navbar-scroll');
      if (navbar) {
        if (window.scrollY > 100) {
          navbar.classList.add('scrolled');
        } else {
          navbar.classList.remove('scrolled');
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const fetchSectionItems = async () => {
      try {
        setLoading(true);
        const response = await sectionItemService.getServicePage(PAGE_SLUG);
        if (response?.success && response.data) {
          setSectionItems(response.data);
        } else {
          setSectionItems({});
        }
      } catch (error) {
        setSectionItems({});
      } finally {
        setLoading(false);
      }
    };

    fetchSectionItems();
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <HeroSection />
      <PainPointsSection items={sectionItems.businessChallenges || []} loading={loading} />
      <SolutionSection items={sectionItems.process || []} loading={loading} />
      <BusinessValueSection items={sectionItems.benefits || []} loading={loading} />
      <LongTermStrategySection items={sectionItems.whyChoose || []} loading={loading} />
      <CTASection />
    </div>
  );
}
